import React from 'react';
import { capitalize } from 'lodash';

import { Table } from 'antd';
import UserData from '../UserData';
import { sanitize } from '../../../../utils/dompurify';

const LLMRecommendations = ({ currentApi, response }) => {
  if (!response?.length) {
    return <div>No Data Found</div>;
  }
  if (typeof response === 'string') {
    // show HTML string in a div
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: sanitize(response) }} />;
  }
  const columns = Object.keys(response[0]).map(key => {
    if (key === 'id' && response[0].userData) {
      return {
        title: capitalize(key),
        dataIndex: key,
        key,
        render: (t, r) => <UserData id={r.id} data={r.userData} />,
      };
    }
    return {
      title: capitalize(key),
      dataIndex: key,
      key,
    };
  });
  const dataSource = response.map(resp => ({
    ...resp,
    metadata: JSON.stringify(resp.metadata),
  }));

  return <Table columns={columns} dataSource={dataSource} />;
};

export default LLMRecommendations;
